import React, { useState } from "react";
import { X } from "react-feather";
import { useIntl } from "react-intl";
import Skeleton from "../../../../components/Skeleton";
import { currencyFormat } from "../../../../utils/format";
import { useAmbient } from '../../../../hooks/ambient';
import "./styles.scss";

const ConfirmationModal = ({ analysisBudget, onClose, onConfirmation }) => {
  const { formatMessage, formatNumber } = useIntl();
  const [isLoading, setIsLoading] = useState(false);

  const { isEnterpriseEnv } = useAmbient();

  function onClickHandler() {
    setIsLoading(true);
    onConfirmation();
  }

  return (
    <>
      <div className="modal confirmation-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "confirmacao-relatorio" })}
            </div>
            <X
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>
          {!isEnterpriseEnv && (
            <section className="modal-card-body">
              {formatMessage({ id: "sera-cobrado" })}{" "}
              {analysisBudget ? (
                formatNumber(analysisBudget, currencyFormat)
              ) : (
                <Skeleton width="40" />
              )}
            </section>
          )}
          <footer className="modal-card-foot">
            <button className="button" onClick={onClose}>
              {formatMessage({ id: "cancelar" })}
            </button>
            <button
              className={`button primary ${isLoading ? "is-loading" : ""}`}
              onClick={onClickHandler}
            >
              {formatMessage({ id: "continuar" })}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;
